import {
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  last1vo29oleiqj36 as last,
  dropLast1vpiyky649o34 as dropLast,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID3gxj6tk5isa35 as VOID,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  copyToArray2j022khrow2yi as copyToArray,
  constructCallableReference23y65rf941mch as constructCallableReference,
  createThis2j2avj17cvnv2 as createThis,
  lazy2hsh8ze7j6ikd as lazy,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  toList383f556t1dixk as toList,
  filterNotNull3qfgcwmxhwfxe as filterNotNull,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  convertToIntofdoxh9bstof as convertToInt,
  until1jbpn0z3f8lbg as until,
  Companion_getInstance1ztf3w4az04w2 as Companion_getInstance,
  fromInt1lka3ktyu79a4 as fromInt,
  Long2qws0ah9gnpki as Long,
  bitwiseAnd2g7wmsfd45l12 as bitwiseAnd,
  shiftLeft1ck77p6vapyra as shiftLeft,
  bitwiseOr1ita6dahwp8zb as bitwiseOr,
  equalsLong28bsrfhwvd686 as equalsLong,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  KtList3hktaavzmj137 as KtList,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  substringBeforeLastqh7oeuvefdek as substringBeforeLast,
  substringAfterLast3r0t0my8cpqhk as substringAfterLast,
  decodeToString1x4faah2liw2p as decodeToString,
  lines3g90sq0zeq43v as lines,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  substringBefore3n7kj60w69hju as substringBefore,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  removePrefix279df90bhrqqg as removePrefix,
  Regexxgw0gjiagf4z as Regex,
  replace3le3ie7l9k8aq as replace,
  startsWith26w8qjqapeeq6 as startsWith,
  printStackTrace18lnx7a39cni as printStackTrace,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  toList3jhuyej2anx2q as toList_0,
  listOf1jh22dvmctj1r as listOf,
  endsWith3cq61xxngobwh as endsWith,
  asSequence2phdjljfh9jhx as asSequence,
  mapNotNull3b8ce5hky4k2l as mapNotNull,
  plus2l6bq32n2wlna as plus,
  contains3ue2qo8xhmpf1 as contains,
  numberToLong345n6tb1n1i71 as numberToLong,
  isNumberiramasdbon0i as isNumber,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  listOfNotNull1v4ggfackvuny as listOfNotNull,
  plus310ted5e4i90h as plus_0,
  to2cs3ny02qtbcb as to,
  toString30pk9tzaqopn as toString_0,
  println2shhhgwwt4c61 as println,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  getKClass3t8tygqu4lcxf as getKClass,
  PrimitiveClasses_getInstance143761yrsca9q as PrimitiveClasses_getInstance,
  first58ocm7j58k3q as first,
  Unitkvevlwgzwiuc as Unit,
  encodeToByteArray1onwao0uakjfh as encodeToByteArray,
} from './kotlin-kotlin-stdlib.mjs';
import {
  DenoPointerpb0vypijx63v as DenoPointer,
  Companion_getInstance1ju3fwn4mt9wh as Companion_getInstance_0,
  toJsBigInt2lj477tra3oly as toJsBigInt,
  get_pointerlkbwhoqlhapz as get_pointer,
  toLong12oqfsfu42e35 as toLong,
  jsObjectr1r5ao37ef4f as jsObject,
  NativeImageRefqizti6jm75 as NativeImageRef,
  get_Deno_isDeno1rvz34wr12yh3 as get_Deno_isDeno,
  toArray1y3va21vj7n9x as toArray,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  get__low2jkzjjmu5faql as get__low,
  get__high277ao55jnazw7 as get__high,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  Deferred6wjx2us769ee as Deferred,
  asDeferredzhtizu7g12ut as asDeferred,
} from './kotlinx-coroutines-core.mjs';
import { Buffer25z94vsj0kb1s as Buffer } from './korlibs-memory-root-korlibs-memory.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance = this;
    this.dbl_1 = get_FFI_SUPPORTED();
  }
  ebl(type) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = type.f1();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = item.ft_1;
      destination.d2(tmp$ret$2);
    }
    var generics = destination;
    var ret = last(generics);
    var params = dropLast(generics, 1);
    return new FuncType(params, ret);
  }
}
class FuncDelegate {
  constructor(base, bname, name, type, config, required) {
    this.fbl_1 = base;
    this.gbl_1 = bname;
    this.hbl_1 = name;
    this.ibl_1 = type;
    this.jbl_1 = config;
    this.kbl_1 = required;
    this.lbl_1 = Companion_getInstance_1().ebl(this.ibl_1);
    this.mbl_1 = this.lbl_1.rbl_1;
    this.nbl_1 = this.lbl_1.sbl_1;
    this.obl_1 = null;
  }
  tbl(thisRef, property) {
    if (this.obl_1 == null)
      this.obl_1 = this.fbl_1.zbl().abm(this.gbl_1, this.ibl_1);
    // Inline function 'korlibs.datastructure.fastCastTo' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.obl_1;
  }
  zq(thisRef, property) {
    return this.tbl(thisRef instanceof FFILib ? thisRef : THROW_CCE(), property);
  }
}
class FuncInfo {
  constructor(type, extraName, config, required) {
    required = required === VOID ? true : required;
    this.bbm_1 = type;
    this.cbm_1 = extraName;
    this.dbm_1 = config;
    this.ebm_1 = required;
  }
  fbm(thisRef, prop) {
    var tmp = prop.callableName;
    var tmp0_elvis_lhs = this.cbm_1;
    // Inline function 'kotlin.also' call
    var this_0 = new FuncDelegate(thisRef, tmp, tmp0_elvis_lhs == null ? prop.callableName : tmp0_elvis_lhs, this.bbm_1, this.dbm_1, this.ebm_1);
    thisRef.xbl_1.d2(this_0);
    if (!thisRef.vbl_1) {
      this_0.tbl(thisRef, prop);
    }
    return this_0;
  }
}
class FFILib {
  static lbm(paths, lazyCreate) {
    Companion_getInstance_1();
    lazyCreate = lazyCreate === VOID ? true : lazyCreate;
    var $this = createThis(this);
    $this.ubl_1 = paths;
    $this.vbl_1 = lazyCreate;
    var tmp = $this;
    tmp.wbl_1 = lazy(FFILib$resolvedPath$delegate$lambda($this));
    var tmp_0 = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_0.xbl_1 = ArrayList.p2();
    $this.ybl_1 = null;
    return $this;
  }
  kbm() {
    var tmp0 = this.wbl_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('resolvedPath', 1, tmp, FFILib$_get_resolvedPath_$ref_dfm5mj(), null);
    return tmp0.k3();
  }
  static mbm(paths, lazyCreate) {
    Companion_getInstance_1();
    lazyCreate = lazyCreate === VOID ? true : lazyCreate;
    return this.lbm(filterNotNull(toList(paths)), lazyCreate);
  }
  nbm() {
    return FFILibSym_0(this);
  }
  zbl() {
    if (this.ybl_1 == null)
      this.ybl_1 = this.nbm();
    return ensureNotNull(this.ybl_1);
  }
  f7() {
    this.zbl().f7();
  }
}
class FFIPointerArray {
  constructor(data) {
    this.obm_1 = data;
  }
  u2(index) {
    Companion_getInstance();
    var tmp2 = this.obm_1[imul(index, 2) + 0 | 0];
    // Inline function 'korlibs.memory.fromLowHigh' call
    var high = this.obm_1[imul(index, 2) + 1 | 0];
    var address = bitwiseOr(bitwiseAnd(fromInt(tmp2), new Long(-1, 0)), shiftLeft(fromInt(high), 32));
    if (equalsLong(address, new Long(0, 0)))
      return null;
    // Inline function 'korlibs.ffi.FFIPointer' call
    return CreateFFIPointer(address);
  }
  s2() {
    return this.obm_1.length / 2 | 0;
  }
  n1() {
    return this.s2() === 0;
  }
  p1() {
    return _get_vlist__9y3qo3(this).p1();
  }
  s4() {
    return _get_vlist__9y3qo3(this).s4();
  }
  x2(index) {
    return _get_vlist__9y3qo3(this).x2(index);
  }
  t4(fromIndex, toIndex) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  pbm(element) {
    var inductionVariable = 0;
    var last = this.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.u2(n), element))
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  y2(element) {
    if (!(element == null ? true : element instanceof DenoPointer))
      return -1;
    return this.pbm((element == null ? true : element instanceof DenoPointer) ? element : THROW_CCE());
  }
  qbm(elements) {
    return _get_vlist__9y3qo3(this).r4(elements);
  }
  r4(elements) {
    return this.qbm(elements);
  }
  rbm(element) {
    return this.pbm(element) >= 0;
  }
  w2(element) {
    if (!(element == null ? true : element instanceof DenoPointer))
      return false;
    return this.rbm((element == null ? true : element instanceof DenoPointer) ? element : THROW_CCE());
  }
  toString() {
    return 'FFIPointerArray(data=' + toString(this.obm_1) + ')';
  }
  hashCode() {
    return hashCode(this.obm_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FFIPointerArray))
      return false;
    var tmp0_other_with_cast = other instanceof FFIPointerArray ? other : THROW_CCE();
    if (!equals(this.obm_1, tmp0_other_with_cast.obm_1))
      return false;
    return true;
  }
}
class FFILibSym {}
function get(name, type) {
  // Inline function 'kotlin.TODO' call
  throw NotImplementedError.le();
}
function close() {
}
class FuncType {
  constructor(params, ret) {
    this.pbl_1 = params;
    this.qbl_1 = ret;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.pbl_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = item == null ? null : item.e1();
      destination.d2(tmp$ret$2);
    }
    tmp.rbl_1 = destination;
    var tmp_0 = this;
    var tmp1_safe_receiver = this.qbl_1;
    tmp_0.sbl_1 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e1();
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    this.sbm_1 = new FFIFuncConfig();
    this.tbm_1 = this.sbm_1.wbm(true);
  }
}
class FFIFuncConfig {
  constructor(wideString, altAbiConvention) {
    Companion_getInstance_2();
    wideString = wideString === VOID ? false : wideString;
    altAbiConvention = altAbiConvention === VOID ? false : altAbiConvention;
    this.ubm_1 = wideString;
    this.vbm_1 = altAbiConvention;
  }
  xbm(wideString, altAbiConvention) {
    return new FFIFuncConfig(wideString, altAbiConvention);
  }
  wbm(wideString, altAbiConvention, $super) {
    wideString = wideString === VOID ? this.ubm_1 : wideString;
    altAbiConvention = altAbiConvention === VOID ? this.vbm_1 : altAbiConvention;
    return $super === VOID ? this.xbm(wideString, altAbiConvention) : $super.xbm.call(this, wideString, altAbiConvention);
  }
  toString() {
    return 'FFIFuncConfig(wideString=' + this.ubm_1 + ', altAbiConvention=' + this.vbm_1 + ')';
  }
  hashCode() {
    var result = getBooleanHashCode(this.ubm_1);
    result = imul(result, 31) + getBooleanHashCode(this.vbm_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FFIFuncConfig))
      return false;
    var tmp0_other_with_cast = other instanceof FFIFuncConfig ? other : THROW_CCE();
    if (!(this.ubm_1 === tmp0_other_with_cast.ubm_1))
      return false;
    if (!(this.vbm_1 === tmp0_other_with_cast.vbm_1))
      return false;
    return true;
  }
}
class FFISyncIOFile {
  constructor(impl, fullPath) {
    this.ybm_1 = impl;
    this.zbm_1 = fullPath;
  }
  obf() {
    return substringBeforeLast(this.zbm_1, _Char___init__impl__6a9atx(47), '');
  }
  h1() {
    return substringAfterLast(this.zbm_1, _Char___init__impl__6a9atx(47));
  }
  x1m() {
    return new FFISyncIOFile(this.ybm_1, this.obf());
  }
  abn() {
    return this.ybm_1.bbn(this.zbm_1);
  }
  cbn() {
    return this.ybm_1.dbn(this.zbm_1);
  }
  ebn() {
    return decodeToString(this.ybm_1.fbn(this.zbm_1));
  }
  gbn() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.ybm_1.hbn(this.zbm_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = this.wi(item);
      destination.d2(tmp$ret$2);
    }
    return destination;
  }
  wi(child) {
    return new FFISyncIOFile(this.ybm_1, this.zbm_1 + '/' + child);
  }
}
class LDLibraries {
  constructor(fs) {
    Companion_getInstance_3();
    this.ibn_1 = fs;
    this.jbn_1 = LinkedHashSet.v2();
    this.kbn_1 = LinkedHashSet.v2();
    var tmp = this;
    tmp.lbn_1 = lazy(LDLibraries$libFoldersInitializeOnce$delegate$lambda(this));
  }
  mbn() {
    return toList_0(_get_libFoldersInitializeOnce__sla0ii(this));
  }
  nbn(path) {
    var file_0 = file(this.ibn_1, path);
    if (file_0.cbn()) {
      this.jbn_1.d2(file_0);
    }
  }
}
class Companion_1 extends LDLibraries {
  constructor() {
    Companion_instance_1 = null;
    super(get_FFIPlatformSyncIO());
    Companion_instance_1 = this;
  }
}
class LibraryResolver {
  constructor(fs, platform) {
    Companion_getInstance_4();
    this.gbm_1 = fs;
    this.hbm_1 = platform;
    var tmp = this;
    tmp.ibm_1 = lazy(LibraryResolver$ldLibraries$delegate$lambda(this));
  }
  obn() {
    var tmp0 = this.ibm_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('ldLibraries', 1, tmp, LibraryResolver$_get_ldLibraries_$ref_j07a4k(), null);
    return tmp0.k3();
  }
  jbm(names) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
      var inductionVariable = 0;
      var last = names.length;
      while (inductionVariable < last) {
        var element = names[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var result = this.pbn(element);
        if (!(result == null)) {
          tmp$ret$0 = result;
          break $l$block;
        }
      }
      tmp$ret$0 = null;
    }
    return tmp$ret$0;
  }
  pbn(name) {
    if (endsWith(name, '.dylib') || endsWith(name, '.so') || endsWith(name, '.dll')) {
      return name;
    }
    var tmp;
    if (this.hbm_1.sb0()) {
      var bases = listOf(['/Library/Frameworks', '/System/Library/Frameworks']);
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
        var _iterator__ex2g4s = bases.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          var base = element + '/' + name + '.framework';
          var tmp_0;
          if (file(this.gbm_1, base).cbn()) {
            tmp_0 = base + '/' + name;
          } else {
            tmp_0 = null;
          }
          var result = tmp_0;
          if (!(result == null)) {
            tmp$ret$0 = result;
            break $l$block;
          }
        }
        tmp$ret$0 = null;
      }
      tmp = tmp$ret$0;
    } else if (this.hbm_1.qb0()) {
      // Inline function 'kotlin.collections.map' call
      var this_0 = listOf([name, name + '.dll', '../' + name + '.dll', '../../' + name + '.dll', '../../../' + name + '.dll', 'C:/WINDOWS/SYSTEM32/' + name + '.dll']);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s_0 = this_0.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var item = _iterator__ex2g4s_0.r1();
        var tmp$ret$4 = file(this.gbm_1, item);
        destination.d2(tmp$ret$4);
      }
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_0 = ArrayList.p2();
      var _iterator__ex2g4s_1 = destination.p1();
      while (_iterator__ex2g4s_1.q1()) {
        var element_0 = _iterator__ex2g4s_1.r1();
        if (element_0.abn()) {
          destination_0.d2(element_0);
        }
      }
      var tmp$ret$8;
      $l$block_0: {
        // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
        var _iterator__ex2g4s_2 = destination_0.p1();
        while (_iterator__ex2g4s_2.q1()) {
          var element_1 = _iterator__ex2g4s_2.r1();
          var result_0 = element_1.zbm_1;
          if (!(result_0 == null)) {
            tmp$ret$8 = result_0;
            break $l$block_0;
          }
        }
        tmp$ret$8 = null;
      }
      tmp = tmp$ret$8;
    } else {
      var tmp_1 = asSequence(this.obn().mbn());
      var tmp_2 = mapNotNull(tmp_1, LibraryResolver$resolve$lambda(name));
      var tmp_3 = asSequence(this.obn().mbn());
      var exactFiles = plus(tmp_2, mapNotNull(tmp_3, LibraryResolver$resolve$lambda_0(name)));
      var tmp$ret$10;
      $l$block_2: {
        // Inline function 'kotlin.sequences.firstOrNull' call
        var _iterator__ex2g4s_3 = exactFiles.p1();
        while (_iterator__ex2g4s_3.q1()) {
          var element_2 = _iterator__ex2g4s_3.r1();
          var tmp$ret$11;
          $l$block_1: {
            if (Companion_getInstance_0().yb0().ib0()) {
              if (contains(element_2, 'i386')) {
                tmp$ret$11 = false;
                break $l$block_1;
              }
            }
            tmp$ret$11 = true;
          }
          if (tmp$ret$11) {
            tmp$ret$10 = element_2;
            break $l$block_2;
          }
        }
        tmp$ret$10 = null;
      }
      tmp = tmp$ret$10;
    }
    return tmp;
  }
}
class Companion_2 extends LibraryResolver {
  constructor() {
    Companion_instance_2 = null;
    super(get_FFIPlatformSyncIO(), Companion_getInstance_0());
    Companion_instance_2 = this;
  }
}
class FFILibSymJS {
  constructor(lib) {
    this.qbn_1 = lib;
    var tmp = this;
    tmp.rbn_1 = lazy(FFILibSymJS$symbolsByName$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.sbn_1 = lazy(FFILibSymJS$dylib$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.tbn_1 = lazy(FFILibSymJS$syms$delegate$lambda(this));
    this.ubn_1 = false;
  }
  vbn() {
    var tmp0 = this.rbn_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('symbolsByName', 1, tmp, FFILibSymJS$_get_symbolsByName_$ref_ymcmq5(), null);
    return tmp0.k3();
  }
  wbn() {
    var tmp0 = this.sbn_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('dylib', 1, tmp, FFILibSymJS$_get_dylib_$ref_bxriyo(), null);
    return tmp0.k3();
  }
  xbn() {
    var tmp0 = this.tbn_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('syms', 1, tmp, FFILibSymJS$_get_syms_$ref_1fqmg2(), null);
    return tmp0.k3();
  }
  abm(name, type) {
    if (this.xbn() == null) {
      var tmp = toString(getKClassFromExpression(this.qbn_1));
      var tmp_0 = this.qbn_1;
      // Inline function 'kotlin.error' call
      var message = "Can't get symbol '" + name + "' for " + tmp + " : '" + toString((tmp_0 instanceof FFILib ? tmp_0 : THROW_CCE()).ubl_1) + "'";
      throw IllegalStateException.o(toString(message));
    }
    var sym = ensureNotNull(this.vbn().w4(name));
    return preprocessFunc(sym.ibl_1, this.xbn()[name], name, sym.jbl_1);
  }
  f7() {
    if (this.ubn_1)
      return Unit_instance;
    this.wbn().close();
    this.ubn_1 = true;
  }
}
class FFIPlatformSyncIO$1 {
  bbn(path) {
    var tmp;
    try {
      Deno.statSync(path);
      tmp = true;
    } catch ($p) {
      var tmp_0;
      var e = $p;
      tmp_0 = false;
      tmp = tmp_0;
    }
    return tmp;
  }
  dbn(path) {
    var tmp;
    try {
      tmp = Deno.statSync(path).isDirectory;
    } catch ($p) {
      var tmp_0;
      var e = $p;
      tmp_0 = false;
      tmp = tmp_0;
    }
    return tmp;
  }
  fbn(path) {
    return Deno.readFileSync(path);
  }
  hbn(path) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = toList(toArray(Deno.readDirSync(path)));
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = item.name;
      destination.d2(tmp$ret$2);
    }
    return destination;
  }
}
//endregion
var Companion_instance;
function Companion_getInstance_1() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function FFILib$resolvedPath$delegate$lambda(this$0) {
  return () => {
    var tmp = Companion_getInstance_4();
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this$0.ubl_1;
    var tmp$ret$0 = copyToArray(this_0);
    return tmp.jbm(tmp$ret$0.slice());
  };
}
function FFILib$_get_resolvedPath_$ref_dfm5mj() {
  return constructCallableReference((p0) => p0.kbm(), 1, 0, 87);
}
function setFFIPointer(_this__u8e3s4, value, byteOffset) {
  byteOffset = byteOffset === VOID ? 0 : byteOffset;
  if (get_FFI_POINTER_SIZE() === 8) {
    set64(_this__u8e3s4, get_address(value), byteOffset);
  } else {
    set32(_this__u8e3s4, convertToInt(get_address(value)), byteOffset);
  }
}
function _get_vlist__9y3qo3($this) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = until(0, $this.s2());
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.n3_1;
  var last = this_0.o3_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$2 = $this.u2(it);
      destination.d2(tmp$ret$2);
    }
     while (!(item === last));
  return destination;
}
var Companion_instance_0;
function Companion_getInstance_2() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function file(_this__u8e3s4, fullPath) {
  return new FFISyncIOFile(_this__u8e3s4, fullPath);
}
var Companion_instance_1;
function Companion_getInstance_3() {
  if (Companion_instance_1 === VOID)
    new Companion_1();
  return Companion_instance_1;
}
function _get_libFoldersInitializeOnce__sla0ii($this) {
  var tmp0 = $this.lbn_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('libFoldersInitializeOnce', 1, tmp, LDLibraries$_get_libFoldersInitializeOnce_$ref_9ap764(), null);
  return tmp0.k3();
}
function loadConfFile($this, file_0) {
  if ($this.kbn_1.w2(file_0))
    return Unit_instance;
  $this.kbn_1.d2(file_0);
  var _iterator__ex2g4s = lines(file_0.ebn()).p1();
  $l$loop: while (_iterator__ex2g4s.q1()) {
    var line = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.text.trim' call
    var tmp$ret$0 = toString(trim(isCharSequence(line) ? line : THROW_CCE()));
    // Inline function 'kotlin.takeIf' call
    var this_0 = substringBefore(tmp$ret$0, _Char___init__impl__6a9atx(35));
    var tmp;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(this_0) > 0) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp0_elvis_lhs = tmp;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      continue $l$loop;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var tline = tmp_0;
    if (startsWith(tline, 'include ')) {
      var glob = removePrefix(tline, 'include ');
      var fullFile = file($this.ibn_1, glob);
      var globFolder = fullFile.x1m();
      var globPattern = Regex.hi('^' + replace(replace(replace(fullFile.h1(), '.', '\\.'), '*', '.*'), '?', '.') + '$');
      if (globFolder.cbn()) {
        var _iterator__ex2g4s_0 = globFolder.gbn().p1();
        while (_iterator__ex2g4s_0.q1()) {
          var item = _iterator__ex2g4s_0.r1();
          if (globPattern.ii(item.h1())) {
            loadConfFile($this, item);
          }
        }
      }
    } else {
      $this.nbn(tline);
    }
  }
}
function LDLibraries$libFoldersInitializeOnce$delegate$lambda(this$0) {
  return () => {
    var tmp;
    try {
      this$0.nbn('/lib');
      this$0.nbn('/usr/lib');
      loadConfFile(this$0, file(this$0.ibn_1, '/etc/ld.so.conf'));
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        tmp_0 = Unit_instance;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return this$0.jbn_1;
  };
}
function LDLibraries$_get_libFoldersInitializeOnce_$ref_9ap764() {
  return constructCallableReference((p0) => _get_libFoldersInitializeOnce__sla0ii(p0), 1, 0, 88);
}
var Companion_instance_2;
function Companion_getInstance_4() {
  if (Companion_instance_2 === VOID)
    new Companion_2();
  return Companion_instance_2;
}
function LibraryResolver$ldLibraries$delegate$lambda(this$0) {
  return () => new LDLibraries(this$0.gbm_1);
}
function LibraryResolver$_get_ldLibraries_$ref_j07a4k() {
  return constructCallableReference((p0) => p0.obn(), 1, 0, 89);
}
function LibraryResolver$resolve$lambda($name) {
  return (folder) => {
    var tries = listOf(['lib' + $name + '.so', $name]);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
      var _iterator__ex2g4s = tries.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        // Inline function 'kotlin.takeIf' call
        var this_0 = folder.wi(element);
        var tmp;
        if (this_0.abn()) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var result = tmp;
        if (!(result == null)) {
          tmp$ret$0 = result;
          break $l$block;
        }
      }
      tmp$ret$0 = null;
    }
    var tmp9_safe_receiver = tmp$ret$0;
    return tmp9_safe_receiver == null ? null : tmp9_safe_receiver.zbm_1;
  };
}
function LibraryResolver$resolve$lambda_0($name) {
  return (folder) => {
    var tmp0 = folder.gbn();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (startsWith(element.h1(), 'lib' + $name) || startsWith(element.h1(), $name)) {
          tmp$ret$0 = element;
          break $l$block;
        }
      }
      tmp$ret$0 = null;
    }
    var tmp10_safe_receiver = tmp$ret$0;
    return tmp10_safe_receiver == null ? null : tmp10_safe_receiver.zbm_1;
  };
}
function get_FFI_POINTER_SIZE() {
  _init_properties_FFILib_js_kt__tqmrqh();
  return FFI_POINTER_SIZE;
}
var FFI_POINTER_SIZE;
function get_FFI_SUPPORTED() {
  _init_properties_FFILib_js_kt__tqmrqh();
  return FFI_SUPPORTED;
}
var FFI_SUPPORTED;
function CreateFFIMemory(size) {
  _init_properties_FFILib_js_kt__tqmrqh();
  return new Uint8Array(size);
}
function getS32(_this__u8e3s4, byteOffset) {
  byteOffset = byteOffset === VOID ? 0 : byteOffset;
  _init_properties_FFILib_js_kt__tqmrqh();
  return (new Deno.UnsafePointerView(_this__u8e3s4.xb1_1)).getInt32(byteOffset);
}
function CreateFFIPointer(ptr) {
  _init_properties_FFILib_js_kt__tqmrqh();
  return equalsLong(ptr, new Long(0, 0)) ? null : get_pointer(Deno.UnsafePointer.create(toJsBigInt(ptr)));
}
function get_pointer_0(_this__u8e3s4) {
  _init_properties_FFILib_js_kt__tqmrqh();
  return get_pointer(Deno.UnsafePointer.of(new Int8Array(_this__u8e3s4.cb2_1.buffer, _this__u8e3s4.cb2_1.byteOffset, _this__u8e3s4.cb2_1.byteLength)));
}
function set32(_this__u8e3s4, value, byteOffset) {
  byteOffset = byteOffset === VOID ? 0 : byteOffset;
  _init_properties_FFILib_js_kt__tqmrqh();
  return getDataView(_this__u8e3s4, byteOffset, 4).setInt32(0, value, true);
}
function CreateFFIMemory_0(bytes) {
  _init_properties_FFILib_js_kt__tqmrqh();
  // Inline function 'kotlin.js.asDynamic' call
  return bytes;
}
function FFILibSym_0(lib) {
  _init_properties_FFILib_js_kt__tqmrqh();
  return new FFILibSymJS(lib);
}
function set64(_this__u8e3s4, value, byteOffset) {
  byteOffset = byteOffset === VOID ? 0 : byteOffset;
  _init_properties_FFILib_js_kt__tqmrqh();
  set32(_this__u8e3s4, get__low(value), byteOffset);
  set32(_this__u8e3s4, get__high(value), byteOffset + 4 | 0);
}
function get_address(_this__u8e3s4) {
  _init_properties_FFILib_js_kt__tqmrqh();
  var tmp = Deno.UnsafePointer;
  var res = tmp.value(_this__u8e3s4 == null ? null : _this__u8e3s4.xb1_1);
  var tmp_0;
  if (isNumber(res)) {
    tmp_0 = numberToLong(res);
  } else {
    // Inline function 'kotlin.js.unsafeCast' call
    tmp_0 = toLong(res);
  }
  return tmp_0;
}
function getDataView(_this__u8e3s4, offset, size) {
  _init_properties_FFILib_js_kt__tqmrqh();
  return new DataView((new Deno.UnsafePointerView(_this__u8e3s4.xb1_1)).getArrayBuffer(size, offset));
}
function FFILibSymJS$symbolsByName$delegate$lambda(this$0) {
  return () => {
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this$0.qbn_1.xbl_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.cd(capacity);
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp$ret$2 = element.gbl_1;
      destination.b5(tmp$ret$2, element);
    }
    return destination;
  };
}
function FFILibSymJS$_get_symbolsByName_$ref_ymcmq5() {
  return constructCallableReference((p0) => p0.vbn(), 1, 0, 90);
}
function FFILibSymJS$dylib$delegate$lambda(this$0) {
  return () => {
    var tmp = this$0.qbn_1;
    if (!(tmp instanceof FFILib))
      THROW_CCE();
    var tmp0 = plus_0(listOfNotNull(this$0.qbn_1.kbm()), this$0.qbn_1.ubl_1);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        var tmp_0;
        try {
          var tmp_1 = Deno;
          // Inline function 'kotlin.collections.map' call
          var this_0 = this$0.qbn_1.xbl_1;
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s_0 = this_0.p1();
          while (_iterator__ex2g4s_0.q1()) {
            var item = _iterator__ex2g4s_0.r1();
            var tmp$ret$4 = to(item.gbl_1, funcToDenoDef(item.ibl_1));
            destination.d2(tmp$ret$4);
          }
          // Inline function 'kotlin.collections.toTypedArray' call
          var tmp$ret$5 = copyToArray(destination);
          tmp_0 = tmp_1.dlopen(element, jsObject(tmp$ret$5.slice()));
        } catch ($p) {
          var tmp_2;
          if ($p instanceof Error) {
            var e = $p;
            printStackTrace(e);
            tmp_2 = null;
          } else {
            throw $p;
          }
          tmp_0 = tmp_2;
        }
        var result = tmp_0;
        if (!(result == null)) {
          tmp$ret$0 = result;
          break $l$block;
        }
      }
      tmp$ret$0 = null;
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.also' call
    var this_1 = tmp$ret$0;
    if (this_1 == null) {
      println("Couldn't load library: dymlib=" + toString_0(this_1) + ' : ' + this$0.qbn_1.kbm());
    }
    return this_1;
  };
}
function FFILibSymJS$_get_dylib_$ref_bxriyo() {
  return constructCallableReference((p0) => p0.wbn(), 1, 0, 91);
}
function FFILibSymJS$syms$delegate$lambda(this$0) {
  return () => {
    var tmp7_safe_receiver = this$0.wbn();
    return tmp7_safe_receiver == null ? null : tmp7_safe_receiver.symbols;
  };
}
function FFILibSymJS$_get_syms_$ref_1fqmg2() {
  return constructCallableReference((p0) => p0.xbn(), 1, 0, 92);
}
function funcToDenoDef(_this__u8e3s4) {
  _init_properties_FFILib_js_kt__tqmrqh();
  var ftype = Companion_getInstance_1().ebl(_this__u8e3s4);
  var tmp0_safe_receiver = ftype.qbl_1;
  var tmp = tmp0_safe_receiver == null ? null : toDenoFFI(tmp0_safe_receiver, true);
  // Inline function 'kotlin.collections.map' call
  var this_0 = ftype.pbl_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var tmp$ret$2 = item == null ? null : toDenoFFI(item, false);
    destination.d2(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$3 = copyToArray(destination);
  return def(tmp, tmp$ret$3.slice(), equals(ftype.sbl_1, getKClass(Deferred)));
}
function preprocessFunc(type, func, name, config) {
  _init_properties_FFILib_js_kt__tqmrqh();
  var ftype = Companion_getInstance_1().ebl(type);
  var convertToString = equals(ftype.sbl_1, PrimitiveClasses_getInstance().sg());
  var retPointer = equals(ftype.sbl_1, getKClass(DenoPointer));
  return preprocessFunc$lambda(ftype, func, convertToString, retPointer, name, type);
}
function def(result, params, nonblocking) {
  nonblocking = nonblocking === VOID ? false : nonblocking;
  _init_properties_FFILib_js_kt__tqmrqh();
  return jsObject([to('parameters', params), to('result', result), to('nonblocking', nonblocking)]);
}
function toDenoFFI(_this__u8e3s4, ret) {
  _init_properties_FFILib_js_kt__tqmrqh();
  if (equals(_this__u8e3s4.e1(), getKClass(Deferred))) {
    var tmp2_safe_receiver = first(_this__u8e3s4.f1()).ft_1;
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.e1();
    return tmp3_safe_receiver == null ? null : toDenoFFI_0(tmp3_safe_receiver, ret);
  } else {
    var tmp5_safe_receiver = _this__u8e3s4 == null ? null : _this__u8e3s4.e1();
    return tmp5_safe_receiver == null ? null : toDenoFFI_0(tmp5_safe_receiver, ret);
  }
}
function getCString(ptr) {
  _init_properties_FFILib_js_kt__tqmrqh();
  if (ptr == null)
    return null;
  return Deno.UnsafePointerView.getCString(ptr.xb1_1);
}
function toDenoFFI_0(_this__u8e3s4, ret) {
  _init_properties_FFILib_js_kt__tqmrqh();
  var tmp;
  if (equals(_this__u8e3s4, getKClass(Long))) {
    tmp = 'usize';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().ng())) {
    tmp = 'i32';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().pg())) {
    tmp = 'f32';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().qg())) {
    tmp = 'f64';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().kg())) {
    tmp = 'i8';
  } else if (equals(_this__u8e3s4, getKClass(NativeImageRef))) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().wg())) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().xg())) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().vg())) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().yg())) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().ah())) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().bh())) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().ug())) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, getKClass(FFIPointerArray))) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, getKClass(Buffer))) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, getKClass(DenoPointer))) {
    tmp = 'pointer';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().sg())) {
    tmp = ret ? 'pointer' : 'buffer';
  } else if (equals(_this__u8e3s4, getKClass(Unit))) {
    tmp = 'void';
  } else {
    // Inline function 'kotlin.TODO' call
    var reason = toString(_this__u8e3s4);
    throw NotImplementedError.le('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function preprocessFunc$lambda($ftype, $func, $convertToString, $retPointer, $name, $type) {
  return () => {
    var arguments_0 = arguments;
    var params = $ftype.rbl_1;
    var inductionVariable = 0;
    var last = params.s2();
    var tmp;
    if (inductionVariable < last) {
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var param = params.u2(n);
        var v = arguments_0[n];
        if (equals(param, PrimitiveClasses_getInstance().sg())) {
          v = encodeToByteArray(toString(v) + '\x00');
        }
        if (v instanceof FFIPointerArray)
          v = v.obm_1;
        if (v instanceof DenoPointer)
          v = v.xb1_1;
        if (v instanceof Buffer)
          v = v.cb2_1;
        if (!(v == null) ? typeof v === 'boolean' : false)
          v = v ? 1 : 0;
        if (v instanceof Long) {
          v = toJsBigInt(v instanceof Long ? v : THROW_CCE());
        }
        arguments_0[n] = v;
      }
       while (inductionVariable < last);
      tmp = Unit_instance;
    }
    var tmp_0;
    try {
      var result = $func.apply(null, arguments_0);
      var tmp_1;
      if (result == null) {
        tmp_1 = null;
      } else if ($convertToString) {
        // Inline function 'kotlin.js.unsafeCast' call
        var ptr = result;
        tmp_1 = getCString(get_pointer(ptr));
      } else if ($retPointer) {
        // Inline function 'kotlin.js.unsafeCast' call
        tmp_1 = get_pointer(result);
      } else {
        tmp_1 = result;
      }
      var res2 = tmp_1;
      var tmp_2;
      if (res2 instanceof Promise) {
        // Inline function 'kotlin.js.unsafeCast' call
        tmp_2 = asDeferred(res2);
      } else {
        tmp_2 = res2;
      }
      tmp_0 = tmp_2;
    } catch ($p) {
      var tmp_3;
      var e = $p;
      println('ERROR calling[' + $name + ']: ' + toString($type) + ' : ' + toString(toList(Array.from(arguments_0))));
      throw e;
    }
    return tmp_0;
  };
}
var properties_initialized_FFILib_js_kt_88mj2t;
function _init_properties_FFILib_js_kt__tqmrqh() {
  if (!properties_initialized_FFILib_js_kt_88mj2t) {
    properties_initialized_FFILib_js_kt_88mj2t = true;
    FFI_POINTER_SIZE = 8;
    FFI_SUPPORTED = get_Deno_isDeno();
  }
}
function get_FFIPlatformSyncIO() {
  _init_properties_FFIPlatformSyncIO_js_kt__byepuc();
  return FFIPlatformSyncIO;
}
var FFIPlatformSyncIO;
var properties_initialized_FFIPlatformSyncIO_js_kt_sxp582;
function _init_properties_FFIPlatformSyncIO_js_kt__byepuc() {
  if (!properties_initialized_FFIPlatformSyncIO_js_kt_sxp582) {
    properties_initialized_FFIPlatformSyncIO_js_kt_sxp582 = true;
    var tmp;
    if (get_Deno_isDeno()) {
      tmp = new FFIPlatformSyncIO$1();
    } else {
      // Inline function 'kotlin.TODO' call
      throw NotImplementedError.le();
    }
    FFIPlatformSyncIO = tmp;
  }
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(FuncDelegate, 'FuncDelegate');
initMetadataForClass(FuncInfo, 'FuncInfo');
initMetadataForClass(FFILib, 'FFILib', VOID, VOID, [AutoCloseable]);
initMetadataForClass(FFIPointerArray, 'FFIPointerArray', VOID, VOID, [KtList]);
initMetadataForInterface(FFILibSym, 'FFILibSym', VOID, VOID, [AutoCloseable]);
initMetadataForClass(FuncType, 'FuncType');
initMetadataForCompanion(Companion_0);
initMetadataForClass(FFIFuncConfig, 'FFIFuncConfig', FFIFuncConfig);
initMetadataForClass(FFISyncIOFile, 'FFISyncIOFile');
initMetadataForClass(LDLibraries, 'LDLibraries');
initMetadataForCompanion(Companion_1);
initMetadataForClass(LibraryResolver, 'LibraryResolver');
initMetadataForCompanion(Companion_2);
initMetadataForClass(FFILibSymJS, 'FFILibSymJS', VOID, VOID, [FFILibSym]);
initMetadataForClass(FFIPlatformSyncIO$1);
//endregion
//region block: exports
export {
  Companion_getInstance_2 as Companion_getInstance3ngdpmt48px2k,
  CreateFFIMemory as CreateFFIMemoryv82e6jbfcdze,
  CreateFFIMemory_0 as CreateFFIMemory2iekizxdvtyvt,
  CreateFFIPointer as CreateFFIPointernsr7ilwulbub,
  FuncInfo as FuncInfocud0a7bce10z,
  FFILib as FFILiby83bova0zjfy,
  getS32 as getS32284qh8a5ldxzn,
  get_pointer_0 as get_pointer2afz2rc14joly,
  set32 as set3216gyp8r69gas8,
  setFFIPointer as setFFIPointerjzarmbova4sm,
};
//endregion
